/*OTHERS*/
import React from "react";

/*MATERIAL UI*/
import { Autocomplete, Button, Dialog, DialogContent, DialogContentText, DialogTitle, Grid, TextField } from "@mui/material";
import DialogActions from '@mui/material/DialogActions';

import { useTranslation } from "react-i18next";

export default function Filter(props: FilterPropsTypes) {
  const { t } = useTranslation();

  const keyPress = (event: any) => {
    if (event.keyCode == 13) {
      props.handleClickFilter();
    }
  }

  return (
    <Dialog
      open={props.openFilter}
      onClose={() => props.setOpenFilter(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      id="filter"
    >
      <DialogTitle id="alert-dialog-title">
        {t("pages.deliveriesFob.text.filterFobCargo")}
        <br />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          <br />
          <Grid>
            <Grid item>
              <>
                <label>{t("common.skus")}:</label>
                <Autocomplete
                  disablePortal
                  id="skus"
                  options={props.filterSkuOptions}
                  value={props.filterSku}
                  multiple={true}
                  onChange={(e: any, newValue: string[] | null) => {
                    props.setFilterSku(newValue ?? [""]);
                  }}
                  renderInput={(params) => <TextField {...params} />}
                  style={{ zIndex: 1000 }}
                  sx={{ width: '100%' }}
                />
              </>
            </Grid>
            {/* <br />
            <Grid item>
              <>
                <label>Contratos</label>
                <Autocomplete
                    disablePortal
                    id="contratos"
                    options={props.filterContratoOptions}
                    value={props.filterContrato}
                    multiple={true}
                    onChange={(e: any, newValue: string[] | null) => {
                      props.setFilterContrato(newValue ?? [""]);
                    }}
                    renderInput={(params) => <TextField {...params} />}
                    style={{zIndex: 1000 }}
                    sx={{ width: '100%' }}
                  />
              </>
            </Grid> */}
            <br />
            <Grid item>
              <TextField
                id={"pedidoId"}
                name={"pedidoId"}
                label={t("common.orderNumber")}
                placeholder={t("common.orderNumber")}
                variant="outlined"
                sx={{ minWidth: "22vw" }}
                value={props.filterPedido}
                onChange={(event) => props.setFilterPedido(event.target.value)}
                onKeyDown={keyPress}
                style={{ width: '100%' }}
              />
            </Grid>
            <br />
            <Grid item>
              <TextField
                id={"itemId"}
                name={"itemId"}
                label={t("common.itemNumber")}
                placeholder={t("common.itemNumber")}
                variant="outlined"
                sx={{ minWidth: "22vw" }}
                value={props.filterItem}
                onChange={(event) => props.setFilterItem(event.target.value)}
                onKeyDown={keyPress}
                style={{ width: '100%' }}
              />
            </Grid>
          </Grid>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="outlined"
          color="success"
          onClick={props.handleClickFilter}
          autoFocus
        >
          {t("common.filter")}
        </Button>
        <Button
          variant="outlined"
          color="success"
          onClick={() => props.setOpenFilter(false)}
          autoFocus
        >
          {t("common.close")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}

interface FilterPropsTypes {
  openFilter: boolean;
  setOpenFilter: any;
  filterPedido: string;
  setFilterPedido: any;
  filterItem: string;
  setFilterItem: any;
  handleClickFilter: any;
  filterSku: string[];
  filterContratoOptions: string[];
  setFilterSku: any;
  filterContrato: string[];
  filterSkuOptions: string[];
  setFilterContrato: any;
}